<template>
  <a-modal :width="props.full ? '100%' : '800px'" v-model:visible="props.visible" :title="user.buildName" :wrap-class-name="props.full ? 'full-modal' : ''"
           @ok="handleOk" :footer="null" @cancel="emit('showMap',false)">
    <a-descriptions :column="2">
      <a-descriptions-item label="查找">
        <a-input-search v-model:value="value" style="width: 220px;" allow-clear placeholder="输入二维码或车位号"
                        @search="onSearch"/>
        <a-button @click="refreshTheDevice" style="margin-left: 20px" v-if="props.full">刷新设备</a-button>
      </a-descriptions-item>
      <a-descriptions-item label="筛选">
        <a-space>
          <a-select
              v-model:value="showArr"
              mode="multiple"
              style="width: 200px"
              placeholder="请选择"
              :max-tag-count="maxTagCount"
              :options="options"
              @change='loadMainSubQuery'
          ></a-select>
          <a-checkbox v-if="showArr.includes('7') || showArr.includes('8')" v-model:checked="turnOnTheCorrelationLine"
                      @change="openLine">开启关联线
          </a-checkbox>
        </a-space>
      </a-descriptions-item>
    </a-descriptions>
    <a-spin :spinning="initMapFlag" tip="地图加载中...">
      <div id='indexMap' :style="props.full ? 'height: calc(93vh - 100px);' : ''">
        <div class='map-floor-group'>
          <div class='floorUp floor_btn'>
            <UpOutlined style="cursor: pointer"/>
          </div>
          <div class='scroll'>
            <ul></ul>
          </div>
          <div class='floorDown floor_btn'>
            <down-outlined style="cursor: pointer"/>
          </div>
        </div>
        <a-tooltip class='item'
                   effect='dark'
                   content='地图居中'
                   placement='top'>
          <div class='mapCenter' @click="mapCenter">
            <img src='@/assets/image/mapCenter.png'
                 alt=''>
          </div>
        </a-tooltip>
      </div>
    </a-spin>
  </a-modal>
</template>
<script setup>
import userStore from "@/stores/user"
import {onMounted, onUnmounted, ref} from "vue";
import bfMap from "@/assets/js/bfmap-app";
import {UpOutlined, DownOutlined} from "@ant-design/icons-vue"
import devStore from "@/stores/devStore";
import load from "@/common/load";
import singleDev from "@/stores/singleDev";
import bfmapData from "@/assets/js/bfmap-data";
import {axiosJSONPost} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import {convertMilliseconds} from "@/utils/index"
import cmd from "@/utils/mqtt/cmd.json"
import mqttTool from "@/utils/mqtt/index2"


let user = userStore()
let dev = devStore();
let single = singleDev();
let props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  search: {
    type: String,
    default: ""
  },
  showType: {
    type: String,
    default: ""
  },
  upgrade: {
    type: Boolean,
    default: false
  },
  channel: {
    type: Boolean,
    default: false
  },
  full: {
    type: Boolean,
    default: false
  }
});
let emit = defineEmits(['showMap'])
let imageArr = ['7', '25', '26', '31', '32', '33', '35', '71'];
let imageErrorCodeArr = ['7','31','32','33'];
const handleOk = () => {
  emit('showMap', false);
};
let showArr = ref([]);
const maxTagCount = ref(2);
let opt = [
  {label: "引导屏", value: '25'},
  {label: "AI盒子(车牌+AOA)", value: '31'},
  {label: "AI盒子(纯车牌识别)", value: '32'},
  {label: "AI盒子(纯AOA运算)", value: '33'},
  {label: "星闪AOA盒子", value: '35'},
  {label: "AI盒子(地锁网关)", value: '71'},
  {label: "摄像头7.0", value: '7'},
  {label: "摄像头8.0", value: '8'},
  {label: "红绿灯", value: '26'},
];
let boxErrorArr = {
  2: '通讯故障',
  4: '加密芯片故障',
};
let cameraErrorArr = {
  2: '通讯故障',
  4: '有车牌空满缺为空',
}
let options = ref([])
let mapType = new Set([]);
// 地图是否加载完成
let initMapFlag = ref(true);
// 开启主副节点关联线
let turnOnTheCorrelationLine = ref(false);
let refreshTheDevice = ()=>{
  dev.getDevStoreList(function () {
    loadMainSubQuery();
  })
}
// 生成关联线
let openLine = () => {
  if (turnOnTheCorrelationLine.value) {
    if (bfMap.map.getLayer(bfMap.currentFloorId + '-deviceLine')) {
      bfMap.map.setLayoutProperty(bfMap.currentFloorId + '-deviceLine', 'visibility', 'visible');
      return;
    }
    let data = dev.devListInfo.deviceList.filter(item => {
      return item.floorId === bfMap.currentFloorId;
    })
    data = data[0].devices;
    // 过滤后的对象
    let obj = {};
    // 存储全部主设备的坐标
    let coordinate = {};
    for (let i = 0; i < data.length; i++) {
      if (data[i].netType === 'main') {
        if (!coordinate.hasOwnProperty(`${data[i].netName}`)) {
          coordinate[`${data[i].netName}`] = data[i].point;
        }
        if (obj.hasOwnProperty(`${data[i].netName}`)) {
          continue;
        }
        obj[`${data[i].netName}`] = [];
      } else if (data[i].netType === 'cm') {
        if (obj.hasOwnProperty(`${data[i].netName}`)) {
          obj[`${data[i].netName}`].push(data[i].point);
          continue;
        }
        obj[`${data[i].netName}`] = [];
        obj[`${data[i].netName}`].push(data[i].point);
      } else {
        continue;
      }
    }
    bfMap.crawLineLayer(bfmapData.crawLineGeoJSON(coordinate, obj), bfMap.currentFloorId + '-deviceLine', 'visible');
  } else {
    bfMap.mapLayerShowHide(bfMap.currentFloorId + '-deviceLine', 'none')
  }

}
// 判断是否是4326 还是3857
let detectCoordinateSystem = (x, y) => {
  if (Math.abs(x) <= 20026376 && Math.abs(y) <= 20048966) {
    return false
  } else {
    return true
  }
}
let loadMainSubQuery = async () => {
  mapType = new Set([]);
  let result = await axiosJSONPost(api.getMapDeviceError, {
    floor_id: bfMap.currentFloorId,
    build_id: bfMap.build,
    md_type: 0,
    dev_type: 0,
    user_level: 1,
  });
  if (result.result !== '1') {
    load.error("获取设备掉线时间列表失败...")
  }
  for (let i = 0; i < dev.filterDevList.deviceList.length; i++) {
    if (dev.filterDevList.deviceList[i].floorId === bfMap.currentFloorId) {
      let mapData = [];
      dev.filterDevList.deviceList[i].devices.forEach(v => {
        for (let j = 0; j < result.device_list.length; j++) {
          if (result.device_list[j].fmn === v.deviceId) {
            v.err_tm = result.device_list[j].err_tm;
            break;
          }
        }
        v.imgSize = 0.3;
        v.point = [Number(v.deviceX), Number(v.deviceY)];
        console.log(!detectCoordinateSystem(Number(v.deviceX), Number(v.deviceY)))
        if (!detectCoordinateSystem(Number(v.deviceX), Number(v.deviceY))) {
          v.point = bfMap.webMercator2LngLat(v.point);
        }
        v.pointX = v.point[0];
        v.pointY = v.point[1];
        if (v.netType === 'main' || v.deviceType === '31' || v.deviceType === '32' || v.deviceType === '33' || v.deviceType === '71') {
          v.img = `devType${v.deviceType}Active`
        } else {
          v.img = `devType${v.deviceType}`
        }

        if (v.online !== 1) {
          v.img = `devType${v.deviceType}Error`;
          if (v.netType === 'main' && v.deviceType === '7') {
            v.text = '主';
            v.textColor = 'red';
          }
        }
        if (v.errCode != 0) {
          let boxErrorArrs = [31, 32, 33].includes(Number(v.deviceType)) ? boxErrorArr : cameraErrorArr;
          if ([31, 32, 33].includes(Number(v.deviceType)) || v.deviceType === '8' || v.deviceType === '7') {
            v.img = `devType${v.deviceType}ErrorCode`;
            let errorText = "";
            for (let boxErrorArrKey in boxErrorArrs) {
              if ((v.errCode & boxErrorArrKey) !== 0) {
                errorText += boxErrorArrs[boxErrorArrKey]
                if (errorText) {
                  errorText += ',';
                }
              }
            }
            v.errorText = errorText;
          }
        }

        if (v.deviceType === '8') {
          v.img = v.img.replace(/8/g, '7')
        }
        mapType.add(v.deviceType)
        if (!showArr.value.includes(v.deviceType)) return
        mapData.push(v);
      })
      options.value = opt.filter(item => {
        return mapType.has(item.value);
      })
      if (props.upgrade) {
        // 传递消息的方法
        mqttTool.deliverTheMessage = loadDevVersion;
        if (mqttTool.subscribeSuccess) {
          mqttTool.doUnSubscribe();
        }
        mapData.forEach(item => {
          if(item.uniqueCode == 0) return
          // 订阅主题
          mqttTool.doSubscribe(false);
          // 发布信息
          mqttTool.subscription.topic = `/mqttshell-return/${item.uniqueCode}` // 默认

          mqttTool.publish.payload = cmd[getDevType(item.uniqueCode)]['upgradeVersion'];
          mqttTool.publish.topic = `/mqttshell/${item.uniqueCode}`;
          mqttTool.doPublish(false);
        });
      }
      if (props.channel) {
        // 传递消息的方法
        mqttTool.deliverTheMessage = loadChannel;
        if (mqttTool.subscribeSuccess) {
          mqttTool.doUnSubscribe();
        }
        mapData.forEach(item => {
          if (!['31', '32', '33', '35'].includes(item.deviceType) || item.uniqueCode == 0) {
            return
          }
          // 订阅主题
          mqttTool.doSubscribe(false);
          // 发布信息
          mqttTool.subscription.topic = `/mqttshell-return/${item.uniqueCode}` // 默认
          console.log(item.uniqueCode)
          console.log(cmd[getDevType(item.uniqueCode)])
          mqttTool.publish.payload = cmd[getDevType(item.uniqueCode)]['channel'];
          mqttTool.publish.topic = `/mqttshell/${item.uniqueCode}`;
          mqttTool.doPublish(false);
        });
      }
      console.log(mapData)
      bfMap.crawDevLayer(bfMap.currentFloorId + '-marker', mapData, 'visible');
      initMapFlag.value = false;
      // 图标点击事件
      bfMap.on('click', function (e) {
        let clickLayerId = '';
        let data = {};
        if (e.features.length > 0) {
          clickLayerId = e.features[0].layer.id.split(bfMap.currentFloorId)[1];
          data = e.features[0].properties;
        }
        data.lngLat = e.lngLat;
        bfMap.map.flyTo({center: e.lngLat});
        showMode(clickLayerId, data);
      });
    }
  }
};
let allDevVersion = ref({})
/**
 * @Date: 2024-12-23 10:19:08
 * @LastEditors: ahuan
 * @description:获取盒子信道
 * @return: 返回值
 */
let timeoutIds;
let allChannel = ref({})
let loadChannel = (topic, msg) => {
  allChannel.value[topic.split('/')[2]] = msg.split(' ')[0]
  // 每次调用时清除之前的计时器，并重新设置
  clearTimeout(timeoutIds);
  timeoutIds = setTimeout(() => {
    console.log(allChannel.value)
    let newData = bfMap.map.getSource(bfMap.currentFloorId + '-marker')._data;
    newData.features.forEach(item => {
      item.properties.text = allChannel.value[item.properties.uniqueCode]
      item.properties.textColor = 'red'
      item.properties.textSize = 12
    })
    bfMap.map.getSource(bfMap.currentFloorId + '-marker').setData(newData)
    //bfMap.crawTextLayer(newData, bfMap.currentFloorId + '-version','visible')
  }, 3000)
}
/**
 * @Date: 2024-11-04 11:04:42
 * @LastEditors: ahuan
 * @description:获取设备版本
 * @return: 返回值
 */
let timeoutId;
let loadDevVersion = (topic, msg) => {
  allDevVersion.value[topic.split('/')[2]] = msg.split(' ')[0]
  // 每次调用时清除之前的计时器，并重新设置
  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    console.log(allDevVersion.value)
    let newData = bfMap.map.getSource(bfMap.currentFloorId + '-marker')._data;
    newData.features.forEach(item => {
      item.properties.text = allDevVersion.value[item.properties.uniqueCode]
      item.properties.textColor = 'red'
      item.properties.textSize = 12
    })
    bfMap.map.getSource(bfMap.currentFloorId + '-marker').setData(newData)
    //bfMap.crawTextLayer(newData, bfMap.currentFloorId + '-version','visible')
  }, 3000)
}
let getDevType = (code) => {
  let type = code.substr(0, 2)
  let index = 0
  switch (type) {
    case 'BA':
      index = '31';
      break;
    case 'B8':
      index = '32';
      break;
    case 'AA':
      index = '33';
      break;
    case 'AB':
      index = '35';
      break;
    case 'A7':
      index = '7';
      break;
    case 'A8':
      index = '8';
      break;
    case 'DC':
      index = '71';
      break;
  }
  return index
}
// 设备点击弹窗
let showMode = (id, data) => {
  if (!data.pointX) {
    return;
  }
  if (bfMap.locationPopup) {
    bfMap.locationPopup.remove();
  }

  let html = "";
  if (id === '-marker') {
    html = `
        <p>二维码：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="changeCode">${data.uniqueCode}</u></p>
        <p>老版本页面：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="openOldMenu">${data.uniqueCode}</u></p>
        <p>设备id：${data.deviceId}</p>
        <p>在线状态：${data.online === 1 ? '在线' : '掉线'}</p>
        <p>主副状态：${data.netType === 'main' ? '主节点' : '辅节点'}</p>
        <p>主节点二维码：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="masternodeQRCode">${data.netName}</u></p>
        <p>老版本主节点页面：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="openOldQRCode">${data.netName}</u></p>
        <p>错误码：${data.errCode}</p>
       ${
      function () {
        if(data.errorText){
          return `<p style="color: red">错误内容：${data.errorText}</p>`
        }else{
          return ''
        }
      }()
    }
        ${function () {
      if (props.upgrade) {
        if (allDevVersion.value[data.uniqueCode]) {
          return `<p>当前版本：${allDevVersion.value[data.uniqueCode]}</p>`
        } else {
          return `<button id="version">获取版本</button>`
        }
      } else {
        return ''
      }
    }()}

        ${data.err_tm ? `<p>已经掉线 <span style="font-size: 20px;font-weight: bold;color:red">${convertMilliseconds(data.err_tm)}</span></p>` : ''}
      `
  } else if (id === '-park-layer') {
    html = `<p>车位号：${data.parknum}</p>`

  }
  if (html) {
    let point = [data.pointX, data.pointY];
    bfMap.locationPopup = bfMap.createPopup(point, html);
    bfMap.map.flyTo({center: point});
  }
  /* eslint-disable */
  $("#openOldMenu").on('click', function () {
    window.open(`http://cn.beefindtech.cn/subservice/mqtt_new/gos8.html?${data.uniqueCode}`)
  })
  $("#openOldQRCode").on('click', function () {
    window.open(`http://cn.beefindtech.cn/subservice/mqtt_new/gos8.html?${data.netName}`)
  })
  /* eslint-disable */
  $('#version').on('click', function () {
    // 订阅主题
    mqttTool.doSubscribe(false);
    // 发布信息
    mqttTool.subscription.topic = `/mqttshell-return/${data.uniqueCode}` // 默认

    mqttTool.publish.payload = cmd[getDevType(data.uniqueCode)]['upgradeVersion'];
    mqttTool.publish.topic = `/mqttshell/${data.uniqueCode}`;
    mqttTool.doPublish(false);
    load.success('发送成功');
    setTimeout(() => {
      if (!allDevVersion.value.hasOwnProperty(data.uniqueCode)) {
        load.error('获取”' + data.uniqueCode + '“版本号失败')
      }
    }, 5000)
  })

  function changeCode(code) {
    let data = dev.devListInfo.deviceList.filter(item => {
      return item.floorId === bfMap.currentFloorId;
    })
    single.changeCurrentCode(code, data[0].devices);
    emit('showMap', false);
  }

  /* eslint-disable */
  $('#changeCode').on('click', function () {
    changeCode($('#changeCode').text())
  })
  $('#masternodeQRCode').on('click', function () {
    changeCode($('#masternodeQRCode').text())
  })
}
onMounted(() => {
  bfMap.initMap('indexMap', user.buildId, function () {
    // 注册图片
    imageArr.forEach(item => {
      bfMap.loadImage("https://beefindtech.com/webProject/mapDataEdit/images/devType" + item + '.png', 'devType' + item);
      bfMap.loadImage("https://beefindtech.com/webProject/mapDataEdit/images/devType" + item + 'Error.png', 'devType' + item + 'Error');
      bfMap.loadImage("https://beefindtech.com/webProject/mapDataEdit/images/devType" + item + 'Active.png', 'devType' + item + 'Active');
    });
    imageErrorCodeArr.forEach(item =>{
      bfMap.loadImage(`https://beefindtech.com/webProject/mapDataEdit/images/devType${item}ErrorCode.png`, `devType${item}ErrorCode`);
    })
    // 切换楼层回调
    bfMap.changeFloor(function () {
      initMapFlag.value = true;
      loadMainSubQuery();
      if (!turnOnTheCorrelationLine.value) {
        bfMap.mapLayerShowHide(bfMap.currentFloorId + '-deviceLine', 'none')
      }
      if (bfMap.locationPopup) {
        bfMap.locationPopup.remove();
      }
    });
    if (props.search) {
      value.value = props.search;
      onSearch();
    }
    if (props.showType) {
      showArr.value.push(props.showType)
    }
    //  加载设备图标
    loadMainSubQuery();
  })

})
onUnmounted(() => {
  bfMap.initMapFlag = false;
  bfMap.currentFloorId = "";
})
// 查询的值
let value = ref("");
// 通过车位号或者二维码查找
let onSearch = () => {
  if (value.value) {
    // 二维码
    if (value.value.length === 8) {
      let state = true;
      for (let i = 0; i < dev.filterDevList.deviceList.length; i++) {
        for (let j = 0; j < dev.filterDevList.deviceList[i].devices.length; j++) {
          if (dev.filterDevList.deviceList[i].devices[j].uniqueCode === value.value || dev.filterDevList.deviceList[i].devices[j].deviceId === value.value) {
            if (dev.filterDevList.deviceList[i].floorId !== bfMap.currentFloorId) {
              load.loading("已找到，正在切换楼层");
              state = false;
              let time = setInterval(() => {
                if (bfMap.map.getLayer(dev.filterDevList.deviceList[i].floorId + '-park-layer')) {
                  clearInterval(time)
                  bfMap.dynamicChageFloor(dev.filterDevList.deviceList[i].floorId, async function () {
                    if (!turnOnTheCorrelationLine.value) {
                      bfMap.mapLayerShowHide(bfMap.currentFloorId + '-deviceLine', 'none')
                    }
                    await loadMainSubQuery();
                    showMode('-marker', dev.filterDevList.deviceList[i].devices[j]);
                  })
                }
              }, 100)

              break
            } else {
              state = false;
              showMode('-marker', dev.filterDevList.deviceList[i].devices[j]);
              break;
            }
          }
        }
      }
      if (state) {
        load.error("未找到，请检查是否输入错误")
      }
    } else {
      // 车位号搜索
      let parkData = [];
      let state = true;
      for (let i = 0; i < dev.filterDevList.deviceList.length; i++) {
        parkData.push(...bfMap.map.getSource(dev.filterDevList.deviceList[i].floorId + '-park-layer')._data.features)
      }
      for (let i = 0; i < parkData.length; i++) {
        if (parkData[i].properties.parknum === value.value) {
          if (parkData[i].properties.floor_id !== bfMap.currentFloorId) {
            load.loading("已找到，正在切换楼层");
            state = false;
            bfMap.dynamicChageFloor(parkData[i].properties.floor_id, async function () {
              if (!turnOnTheCorrelationLine.value) {
                bfMap.mapLayerShowHide(bfMap.currentFloorId + '-deviceLine', 'none')
              }
              await loadMainSubQuery();
              showMode('-park-layer', parkData[i].properties);
            })
            break
          } else {
            state = false;
            showMode('-park-layer', parkData[i].properties);
            break
          }
        }
      }
      if (state) {
        load.error("未找到，请检查是否输入错误")
      }
    }
  } else {
    load.error("请输入");
  }
}
let mapCenter = () => {
  bfMap.setMapCenter(bfMap.currentFloorId);
}
</script>
<style scoped lang="scss">
#indexMap {
  margin-top: 20px;
  height: 530px;
}
</style>
<style lang="scss">
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
}
.mapboxgl-ctrl-logo {
  display: none !important;
}
.mapboxgl-ctrl-attrib-button{
  display: none !important;
}
#indexMap {
  .mapboxgl-popup-close-button {
    display: none;
  }

  .active {
    background: #409EFF;
    color: #fff
  }

  .map-floor-group > .scroll > ul > li {
    cursor: pointer;
    width: 30px;
    height: 30px;
    font-size: 13px;
    border-radius: 50%;
    position: relative;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-weight: 700;
  }

  .mapCenter {
    width: 40px;
    position: absolute;
    right: 32px;
    top: 65%;
    z-index: 999;
    cursor: pointer;
  }

  .proCheck {
    width: 100px;
    position: absolute;
    right: 44px;
    top: 45px;
    z-index: 999;
    background: #fff;
    opacity: .8;
    padding: 5px 0 0 5px;
    color: white;
    display: flex;
    flex-direction: column;
  }

  .mapCenter img {
    width: 100%;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .map-floor-group {
    -webkit-box-shadow: 0 0 0.1rem hsla(0, 0%, 80%, 0.8);
    box-shadow: 0 0 0.1rem hsla(0, 0%, 80%, 0.8);
    border-radius: 22px;
    background-color: #fff;
    text-align: center;
    color: #464c5b;
    position: absolute;
    -webkit-transition: all .5s;
    transition: all .5s;
    right: 30px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    padding: 8px;
    z-index: 99999;
  }

  .map-floor-group > .floor_btn.off {
    color: #eee
  }

  .map-floor-group > .scroll {
    position: relative
  }

  .map-floor-group > .scroll > ul {
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    margin: 0;
  }
}
</style>
